<template lang="pug">
    div(id="kt-revenue-forecasting")
        div(class='kt-revenue-forecasting-header')
            div(class="teamFilter")
                slot(name="team-member-filter" :fCU="false" :fTM="d_canSG")
        div(class="kt-revenue-forecasting-content")
            div(class="rf-revenue-view-bar")
                div(class="rf-revenue-view-group")
                    span(class="rf-revenue-view-lbl") Revenue View
                    b-form-radio-group(
                        v-model="d_revenueView"
                        :options="c_revenueViewOptions"
                        buttons
                        button-variant="outline-secondary"
                        size="sm"
                    )
                div(class="rf-revenue-view-divider")
                div(class="rf-forecast-filter-group")
                    span(class="rf-revenue-view-lbl") Revenue Forecast Filter
                    b-dropdown.rf-forecast-filter(variant="none" no-caret right style="border:none;" menu-class="export-menu")
                        template(v-slot:button-content)
                            fa-icon(icon="filter" title="Filter")
                        div(class="rf-forecast-filter-panel" @click.stop)
                            div(class="rf-forecast-filter-section")
                                label From
                                b-form-input(type="date" size="sm" v-model="d_forecastFilter.fromDate")
                            div(class="rf-forecast-filter-section")
                                label To
                                b-form-input(type="date" size="sm" v-model="d_forecastFilter.toDate")
                                
                            <!-- STAGE FILTER -->
                            details( open @toggle="m_closeOthers($event)")
                                summary(class="primary")
                                    strong Stage

                                div(class="rf-forecast-stage-list")
									
                                     div(class="rf-forecast-stage-item" v-for="stage in d_stageOptions" :key="stage")
                                        b-form-checkbox(:value="stage" v-model="d_forecastFilter.selectedStages") {{ stage }}                                     

                                     div(class="d-flex")
                                        b-form-checkbox(  :value="true" v-model="d_forecastFilter.allStages" )
                                        small(class="text-muted" ) All Stages
                                            
											 
                            <!-- STATUS FILTER -->
                            details( open @toggle="m_closeOthers($event)")
                                summary(class="primary")
                                    strong Status

                                div(class="rf-forecast-status-list")
									
                                     div(class="rf-forecast-stage-item" v-for="status in d_statusOptions" :key="status")
                                        b-form-checkbox(:value="status" v-model="d_forecastFilter.selectedStatuses") {{ status }}
                                             
                                     div(class="d-flex")
                                        b-form-checkbox(:value="true" v-model="d_forecastFilter.allStatuses" )
                                        small(class="text-muted" ) All Statuses
                                            
                            
                            div
                                kt-range-slider(v-model="d_forecastFilter.winProbability" :min="0" :max="100" labelText="WinProbability")
                    div(class="rf-forecast-filter-toggles")
                        label(class="rf-forecast-toggle-oppr")
                            input(type="checkbox" v-model="d_forecastFilter.showOpportunities")
                            span Opportunities
                        label(class="rf-forecast-toggle-proj")
                            input(type="checkbox" v-model="d_forecastFilter.showProjects")
                            span Projects
                    div(class="d-flex ml-auto buttonBar")
                        b-button(id="btn-save" class="btn-save"  title="Save" variant="none" @click="m_save()") 
                            fa-icon(icon="save" class="mr1-1")
                            sup Save
                        b-button(id="btn-cancel" class="btn-cancel" title="Cancel" variant="none" @click="m_cancel()") 
                            fa-icon(icon="undo" class="mr1-1")
                            sup Cancel                      
            b-card(no-body)
                b-card-header
                    b-button(variant="none" v-b-toggle="'bc-rf-project-info'")
                        fa-icon(icon="chevron-down")
                    span Project Information
                b-collapse(id="bc-rf-project-info" visible=true)
                    div(class="rf-project-info-wrap")
                        kt-forecast-project-information(
                            :projects="c_filteredForecastProjects"
                            @change="m_onForecastProjectsChange"
                            @updateBusinessInsight="m_updateBusinessInsight"
                        )
            b-card(no-body)
                b-card-header
                    b-button(variant="none" v-b-toggle="'bc-rf-forecast-charts'")
                        fa-icon(icon="chevron-down")
                    span Forecasting Charts
                b-collapse(id="bc-rf-forecast-charts" visible=true)
                    div(class="rf-forecast-charts-wrap")
                        kt-portfolio-forecast(
                            :projects="c_filteredForecastProjects"
                            :display-projects="c_filteredForecastProjects"
                            :forecast-filter="d_forecastFilter"
                            :revenue-view="d_revenueView"
                        )


</template>
 <script>
import {fn_getRevenueForecastData,fn_saveRevenueForecastData} from "@/utils/api.js";
import util, {kbdpAlert, fn_getModal_addGoal} from "@/utils/util.js";
import {userSettings, userInfo, refData} from "@/utils/ref-data.js";

import VueGauge from "vue-gauge";
import KTPortfolioForecast from "@/components/Ctrl/KT-PortfolioForecast.vue";
import KTForecastProjectInformation from "@/components/Ctrl/KT-ForecastProjectInformation.vue";
import {fn_filterForecastProjects, fn_stageOptionsForProjects,fn_statusOptionsForProjects, REVENUE_VIEW_CONTRACT, REVENUE_VIEW_FEE } from "@/utils/forecastUtils.js";
import KTRangeSlider from "@/components/Ctrl/KT-RangeSlider.vue";


const const_bkp = {};
export default {
    name: "kt-revenue-forecasting",
    components: {
        'vue-gauge': VueGauge,
        'kt-portfolio-forecast': KTPortfolioForecast,
        'kt-forecast-project-information': KTForecastProjectInformation,
        'kt-range-slider':KTRangeSlider,
    },
    beforeCreate() {
        let kbdp = this.$parent;
        const_bkp.cu = kbdp.d_cuFilter;
        const_bkp.tm = kbdp.d_tmFilter;
    },
    beforeDestroy() {
        if (!this.d_canSG) {
            let kbdp = this.$parent;
            kbdp.d_cuFilter = const_bkp.cu;
            kbdp.d_tmFilter = const_bkp.tm;
        }
    },
    created() {
        let kbdp = this.$parent;
        this.d_canSG = userSettings.permissions.STMSG === true;
        if (this.d_canSG) {
            this.d_tmFilter = kbdp.d_tmFilter;
            this.d_isCU = null;
            kbdp.d_cuFilter = null;
        }
        else {
            this.d_tmFilter = userInfo.getUserInfo().teamMember;
            this.d_isCU = true;
            kbdp.d_cuFilter = true;
        }
        
        
        fn_getRevenueForecastData().then(resp => {
                    
                    this.d_forecastProjects=[...resp.recordData];
                    //this.d_forecastData=[...resp.recordData];
                    this.d_stageOptions =[...fn_stageOptionsForProjects(this.d_forecastProjects)];
                    this.d_statusOptions =[...fn_statusOptionsForProjects(this.d_forecastProjects)];
                });
                
        
    },
    mounted() {},
    data() {
        let curYr = new Date().getFullYear();
        return {
            d_currYr: curYr,
            d_currDt: new Date().toLocaleDateString(),
            d_canSG: null,
            d_tmFilter: null,
            d_isCU: null,

            d_goals: [],
            d_goalsRows: {m: [], q: []},

            d_metrics: {
                selYr: curYr,
                data: {},
                fn_chg: () => fn_getSalesGoals_Mtrcs(this)
            },
            d_notes: {
                selYr: curYr,
                data: [],
                fn_chg: () => fn_getSalesGoals_Notes(this)
            },

            d_forecastProjects:null,
            d_revenueView: REVENUE_VIEW_CONTRACT,
            d_forecastFilter: {
                fromDate: `${curYr}-01-01`,
                toDate: `${curYr + 1}-03-31`,
                selectedStages: [],
                allStages: true,
                selectedStatuses: [],
                allStatuses: true,
                showOpportunities: true,
                showProjects: true,
                winProbability:{min:0, max:100}
            },
            d_revenueBusinessInsightUpdates:[],
            d_forecastData:[],
            d_businessInsightUpdates:[],
            d_stageOptions:[],
            d_statusOptions:[],

        };
    },
    props: {},
    computed: {
        c_revenueViewOptions() {
            return [
                { text: 'Contract Value', value: REVENUE_VIEW_CONTRACT },
                { text: 'Fee Value', value: REVENUE_VIEW_FEE },
            ];
        },
        c_filteredForecastProjects() {
            if (!this.d_forecastProjects?.length) return [];

            const filtered = fn_filterForecastProjects(
            this.d_forecastProjects,this.d_forecastFilter);

        return [...filtered]; // force new reference
    },

        
        c_forecastStageOptions() {
            return fn_stageOptionsForProjects(this.d_forecastProjects);
        },
        c_tmFilter() {
            return this.$parent.d_tmFilter;
        },
        c_yrs() {
            let yrs = this.d_goals.map(x => x.yr);
            yrs.push(this.d_currYr);
            yrs = yrs.filter((val, ix, arry) => arry.indexOf(val) === ix);
            yrs = yrs.sort((a, b) => a.yr < b.yr ? 1 : -1);

            return yrs.map(x => ({text: x, value: x}));
        },
        c_bcSGs() {
            //B-Collapse Revenue Forecast
            // console.log('c_bcSGs', this.d_goals.length);
            let pfx = this.d_isCU ? 'My ' : '';
            let out = [
                {
                    prdKey: 'm',
                    key: 'monthly',
                    lbl: pfx + 'Monthly Revenue Forecast',
                    goals: this.d_goals.filter(x => x.prdKey == 'm').sort((a, b) => a.yr < b.yr ? 1 : -1),//!!Sort = IMPORTANT
                    goalsRows: this.d_goalsRows['m'],
                    rowLbls: refData.months,
                },
                {
                    prdKey: 'q',
                    key: 'quarterly',
                    lbl: pfx + 'Quarterly Revenue Forecast',
                    goals: this.d_goals.filter(x => x.prdKey == 'q').sort((a, b) => a.yr < b.yr ? 1 : -1),//!!Sort = IMPORTANT
                    goalsRows: this.d_goalsRows['q'],
                    rowLbls: [1, 2, 3, 4].map(q => 'Qtr' + q),
                }
            ];
            out.forEach((MoQtr, ix) => {

                MoQtr.keyLbl = util.fn_humanizeLabel(MoQtr.key);

                fn_setGoalsRows(this, MoQtr);

                let glsVsb = MoQtr.goals.filter(g => g.vsbl);
                MoQtr.thTgtAct = !glsVsb.length ? [] : glsVsb.map(g => {
                    let arry = ['Act'];
                    // if (g.ovrdAct) arry[0] += 'Ovrd';
                    if (g.vsblTgt) arry.unshift('Tgt');
                    return arry;
                }).reduce((x, y) => x.concat(y));
            });
            return out;
        },
        c_qtgTtl() {
            let cy = this.d_goals.filter(x => x.yr == this.d_metrics.selYr);
            if (!cy.length) return null;
            cy = cy.length == 1 ? cy[0] : cy.filter(x => x.prdKey == 'q')[0];
            return cy.ttlVal;
        },
        c_qtgG() {
            //Quest to Goal - Goal Metrics
            let qtgTtl = this.c_qtgTtl;

            if (!qtgTtl) return {};
            let pctOfTgt = !qtgTtl.Tgt ? 0 : Math.round(qtgTtl.Act * 100 / qtgTtl.Tgt);

            let arcClr = pctOfTgt < 10 ? '#dc3545' : pctOfTgt > 90 ? '#28a745' : '#a1cbc9';
            let arcDlm = pctOfTgt >= 100 ? 99 : (pctOfTgt || 1);
            let qtg = {
                vgKey: pctOfTgt,
                vgOpts: {
                    chartWidth: 200,
                    rangeLabel: ['0%', '100%'],

                    arcColors: [arcClr, '#e9ecef'],
                    arcDelimiters: [arcDlm],

                    arcLabels: [util.fn_fmtMoney(qtgTtl.Act, true)],
                    centralLabel: pctOfTgt + '%',
                    // outerNeedle: true,
                    needleValue: pctOfTgt,
                    needleColor: '#4fa4ff',
                },
                items: [
                    {
                        lbl: 'Annual Target',
                        val: this.m_valFmt(qtgTtl.Tgt),
                        pct: null,
                        pctLbl: null,
                        class: 'Tgt',
                    },
                    {
                        lbl: 'Achieved',
                        val: this.m_valFmt(qtgTtl.Act),
                        pct: pctOfTgt,
                        pctLbl: "% of Target",
                        class: ['Act'],
                    },
                ]
            };

            if (qtgTtl.Tgt >= qtgTtl.Act) {
                qtg.items.push({
                    lbl: 'Remaining',
                    val: this.m_valFmt(qtgTtl.Tgt - qtgTtl.Act),
                    pct: !qtgTtl.Tgt ? null : ((qtgTtl.Tgt - qtgTtl.Act) * 100 / qtgTtl.Tgt).toFixed(0),
                    pctLbl: '% of Target',
                    class: qtgTtl.Tgt === null ? null : 'Rem',
                });
            }
            else {
                qtg.items.push({
                    lbl: 'Exceeded by',
                    val: this.m_valFmt(qtgTtl.Act - qtgTtl.Tgt),
                    pct: !qtgTtl.Tgt ? null : ((qtgTtl.Act - qtgTtl.Tgt) * 100 / qtgTtl.Tgt).toFixed(0),
                    pctLbl: '% of Target',
                    class: 'Exc',
                });
            }
            return qtg;
        },
        c_qtgP() {
            //Quest to Goal - Pipeline Metrics

            let selYr = this.d_metrics.selYr;
            let isPY = selYr < this.d_currYr; //Previous Year

            let op = this.d_metrics.data;
            let ppl = [
                {
                    lbl: 'Opportunities in Pipeline',
                    val: op.opprCnt || '0',
                    info: `# of Opportunities that are due in ${selYr}, and the selected Team Member is the “Internal Contact”. \n\
                    The metric for prior years include both awarded and not awarded opportunities, \
                    while metric for current or future years only include opportunities that are not yet awarded (deal in progress). \n\
                    Opportunities “Not Pursued” and ”Archived” are excluded.`
                },
                {
                    lbl: 'Total Pipeline Value',
                    val: op.valSum == undefined ? null : '$' + this.m_valFmt(op.valSum),
                    info: 'Total value of the opportunities in pipeline'
                },
                {
                    lbl: 'Win Probability (average)',
                    val: op.winPrbAvg == undefined ? null : op.winPrbAvg + '%',
                    info: 'Average "Win Probability" (dropdown selection) of the opportunities in pipeline'
                },

                {
                    lbl: 'Win Rate' + (isPY ? '' : ' (last 12 mo)'),
                    val: op.winRate == undefined ? null : op.winRate + '%',
                    info: `% (ratio) of opportunities awarded vs non-awarded, and were due in ${isPY ? selYr : 'the last 12 months'}, \
                    and the selected Team Member is the “Internal Contact”. \n\
                    Opportunities “Not Pursued” and ”Archived” are excluded.`
                },
                {
                    lbl: 'High Probable Opportunities',
                    val: op.opprCntHP || '0',
                    info: '# of Opportunities in pipeline with 80% or higher Win Probability'
                },
                {
                    lbl: 'High Probable Pipeline Value',
                    val: op.valSumHP == undefined ? null : '$' + this.m_valFmt(op.valSumHP),
                    info: 'Total value of high probable Opportunities in pipeline (80% or higher Win Probability.)'
                },

            ];


            if (isPY) return ppl;


            //Only applicable for current/future years
            let qtgTtl = this.c_qtgTtl;
            let rem = qtgTtl ? qtgTtl.Tgt - qtgTtl.Act : null;
            if (rem > 0) {
                if (op.valSum >= 0) {
                    let tpv = ppl[1];
                    tpv.pct = (op.valSum * 100 / rem).toFixed(0);
                    tpv.pctLbl = '% of Remaining';

                }

                if (op.valSumHP >= 0) {
                    let hpv = ppl[5];
                    hpv.pct = (op.valSumHP * 100 / rem).toFixed(0);
                    hpv.pctLbl = '% of Remaining';
                }
            }

            return ppl;
        },
    },
    methods: {
        m_onForecastProjectsChange(projects) {
            this.d_forecastProjects = projects;
        },
        m_valFmt(val) {
            if (val === null || val === '') return null;
            else if (!isNaN(val)) return Number(val).toLocaleString('en');
        },
        m_valChg(gv, chgVal) {
            let val = (chgVal || '').replaceAll(',', '').trim();

            if (isNaN(val)) {
                gv.state = false;
                gv.valVM = chgVal;
            }
            else {
                gv.state = null;
                gv.valVM = this.m_valFmt(val);

                gv.valRef[gv.key] = val == '' ? null : Number(val);

                if (gv.key == 'Act') {
                    gv.valRef.ActOvrd = val == '' ? null : true;
                }

                let gr = gv.goalRef;
                gr.fn_calcYrTtl(gv.key);
            }
        },
        m_updateBusinessInsight(data){
            let biIndex = this.d_businessInsightUpdates.findIndex(b=>b.recordId == data.recordId &&
                                                                    b.recordType == data.recordType &&
                                                                    b.propName == data.propName);
            if(biIndex > -1) {
                this.d_businessInsightUpdates[biIndex].valueDEC=data.valueDEC;
                this.d_businessInsightUpdates[biIndex].valueVNC=data.valueVNC;
                }
                else {this.d_businessInsightUpdates.push(data);}
            
            console.log('d_businessInsightUpdates',this.d_businessInsightUpdates);
                
        },
        async m_save(){
            if(this.d_businessInsightUpdates.length) {
                try {
                    const resp = await fn_saveRevenueForecastData(this.d_businessInsightUpdates)
            
                    if (resp.error) {
                        let msg = `Unable to save Revenue Forecast changes Error: ${error.message || error}`;
                        kbdpAlert.showErr(msg);
                    } else {
                        kbdpAlert.showOk('Revenue Forecast changes' + " was saved successfully.");
                
                        this.d_forecastData = [...this.d_forecastProjects]; 
                        }       
            
            } catch (error) {
                let msg = `Unable to save Revenue Forecast changes Error: ${error.message || error}`;
                kbdpAlert.showErr(msg);
                }
            }
        
        },
        m_cancel() {
            this.d_businessInsightUpdates.length=0;
            this.d_forecastProjects = [...this.d_forecastData]; 
        },
        m_closeOthers(event) {
		 const all = this.$el.querySelectorAll("details");
		 
         if (!event.target.open) {
		 all.forEach(d => {if (d !== event.target) d.open = true;})
		 return
         }
         
         all.forEach(d => {if (d !== event.target) d.open = false;})
      },        
    },
    watch: {
        c_tmFilter(nv, ov) {
            if (!this.d_canSG) return;
            this.d_tmFilter = nv;

        },
		
  // STAGES
  'd_forecastFilter.allStages'(val) {
    if (val) {
      // Check all
      this.d_forecastFilter.selectedStages = [...this.d_stageOptions];
    }
    // If val becomes false, do nothing — user may be unchecking manually
  },

  'd_forecastFilter.selectedStages'(val) {
    // If user unchecks any single stage → turn off All Stages
    this.d_forecastFilter.allStages = val.length === this.d_stageOptions.length;
  },


  // STATUSES
  'd_forecastFilter.allStatuses'(val) {
    if (val) {
      this.d_forecastFilter.selectedStatuses = [...this.d_statusOptions];
    }
  },

  'd_forecastFilter.selectedStatuses'(val) {
    this.d_forecastFilter.allStatuses = val.length === this.d_statusOptions.length;
  }
   
}
 
};

function fn_wss_uc_rem(vc) {
    if (vc.d_goals.filter(x => x.fn_isEdt()).length == 0) util.fn_wss_uc(false);
}

</script>

<style lang="less">
#kt-revenue-forecasting {
    height: 100%;
    > .kt-revenue-forecasting-header {
        display: flex;
        flex-wrap: wrap;

        border-bottom: solid 0.1em #adb5bd;
        padding-bottom: 0.2em;
        margin-bottom: 0.3em;
    }
    > .kt-revenue-forecasting-content {
        height: inherit;
        // border: solid 0.1em red;
        div.card {
            margin-bottom: 1em;
            > div.card-header {
                padding: 0.2em;
                line-height: 1em;
                font-size: 0.9em;
                // text-align: left;
                display: flex;
                > button {
                    height: 20px;
                    line-height: inherit;
                    padding: 0 0.2em;
                    &.collapsed {
                        transform: rotate(-90deg);
                    }
                    &:hover {
                        background-color: #dee2e6;
                    }
                }
                > span {
                    padding-left: 0.5em;
                    flex-grow: 1;
                    margin: auto 0;
                }
                > select {
                    width: 60px;
                    font-size: 0.9em;
                }
            }
            > div:nth-child(2) {
                padding: 0.2em 0.5em;

                p.note {
                    padding: 1em 0;
                    margin-bottom: 0;
                    text-align: center;
                    font-size: 14px;
                }
            }
        }
    }
}
#bc-rf-by-monthly,
#bc-rf-by-quarterly {
    font-size: 0.9em;

    > div > div.header {
        padding: 0.2em 0;
        display: flex;
        .btn {
            font-size: 0.9em;
            margin-right: 0.5em;
        }

        div.dropdown {
            margin-left: auto;
            ul.dropdown-menu {
                padding: 0.5em 0;
            }
            .dropdown-item {
                width: 100px;
                padding: 0.2em 0.5em;
                display: flex;
                input {
                    margin: auto 0;
                }
                span {
                    cursor: default;
                    padding-left: 0.5em;
                    // font-size: 0.9em;
                }
            }
        }
    }

    > div > div.content {
        overflow-x: auto;

        > div.info {
            text-align: left;

            > div {
                display: flex;
                // flex-wrap: nowrap;
                margin-bottom: 0.5em;
                > span:first-child {
                    width: 25px;
                    flex-shrink: 0;
                    text-align: center;
                    > svg {
                        font-size: 1.2em;
                        color: #dc3545;
                    }
                }
                > span:nth-child(2) {
                    font-size: 0.9em;
                }
            }
        }
    }
    table {
        font-size: 0.9em;
        width: unset;

        thead {
            tr th {
                vertical-align: middle;
                padding: 0.2em 0.5em;
                // text-align: center;
                min-width: 90px;
                // border-bottom: solid 0.1em #343a40;
                border: none;
                font-weight: normal;
            }
            th.yr {
                // height: 31px;

                > span:nth-of-type(2) {
                    vertical-align: middle;
                    font-weight: bold;
                    margin: 0 0.4em;
                }

                > .dropdown {
                    .dropdown-toggle {
                        font-size: 0.9em;
                        svg {
                            color: #4fa4ff;
                        }
                    }
                    .dropdown-item {
                        border-bottom: solid 0.1em #ced4da;
                        padding: 0.2em 0.5em;
                        min-width: 100px;

                        cursor: pointer;
                        svg {
                            margin-right: 0.4em;
                            color: #6c757d;

                            &.fa-check {
                                color: #28a745;
                            }
                            &.fa-times {
                                color: #dc3545;
                            }
                            &.fa-pencil-alt {
                                color: #4fa4ff;
                            }
                        }

                        // &.ovrAct svg.fa-pencil-alt {
                        //  color: #dc3545;
                        // }
                    }
                    &.no-tgt-col .tgl-tgt:after {
                        content: "Show Targets";
                    }
                    &:not(.no-tgt-col) .tgl-tgt:after {
                        content: "Hide Targets";
                    }
                }
                > .btns {
                    padding-bottom: 0.4em;
                    button {
                        font-size: 1em;
                        margin: 0 0.2em;
                    }
                }
            }

            tr.tgt-act {
                th {
                    line-height: 1em;
                    text-align: right;
                    padding-right: 0.5em;
                    padding-bottom: 0.4em;
                    border-bottom: solid 0.2em #6c757d;
                }
                th.Tgt::before {
                    content: "Target";
                }
                // th.ActOvrd,
                th.Act {
                    &::before {
                        content: "Actual";
                    }
                    svg {
                        color: #dc3545;
                        margin-left: 0.75em;
                    }
                }
            }
        }
        tbody {
            tr td {
                padding: 0.3em 0.5em;
                vertical-align: middle;
            }
            tr td:first-child {
                text-align: left;
                // border-right: solid 0.1em #ced4da;
            }
            tr td:not(:first-child) {
                text-align: right;
                font-size: 0.85em;
                height: 31px;

                > div.input-group {
                    max-width: 110px;
                    margin: 0 auto;
                }
                div.input-group-text {
                    font-size: 1em;
                    // background-color: #f8f9fa ;
                }

                > span,
                > div input {
                    line-height: 1em;
                    font-size: 1.3em;
                    text-align: right;
                }
                > span {
                    display: inline-block;
                    &::before {
                        content: "$";
                    }
                    &:empty::before {
                        content: "-";
                        padding-right: 0.5em;
                    }
                }
                &.Act.ActOvrd {
                    > div,
                    > span {
                        &::after {
                            content: "*";
                            padding-left: 0.2em;
                        }
                    }
                }

                svg {
                    margin: auto 0;
                    margin-left: 0.3em;
                    color: #dc3545;
                    // &.fa-pencil-alt {
                    //  font-size: 9px;
                    // }
                    &.fa-exclamation {
                        font-size: 11px;
                    }
                }

                &.Tgt {
                    padding-left: 1em;
                }
            }

            tr:last-child {
                background-color: #f8f9fa;
                font-size: 1.1em;
                td {
                    padding: 0.6em 0.3em;
                    border-top: solid 0.2em #343a40;
                    font-weight: bold;
                }
                input {
                    font-weight: bold;
                }
            }
        }

        thead tr th.yr,
        thead tr th.Act,
        tbody tr td.Act {
            &:not(:last-child) {
                border-right: solid 0.3em #dee2e6;

                &:not(.yr) {
                    padding-right: 1em;
                }
            }
        }
    }

    input:invalid {
        border-color: #dc3545;
        box-shadow: none;
    }
}

#bc-rf-quest-tg {
    // overflow-x: auto;
    max-width: 800px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    > div {
        // border: solid 0.1em red;
        margin-bottom: 0.5em;
        padding-right: 1em;
        flex-grow: 1;
        text-align: left;

        > div.hdr {
            font-size: 0.9em;
            font-weight: bolder;
            padding-bottom: 0.5em;
            text-decoration: underline;
        }

        > div.item {
            display: flex;
            font-size: 0.9em;
            padding: 0.2em 0;

            > div:nth-child(2) {
                span:nth-child(1) {
                    font-weight: bolder;
                }
                span:nth-child(2) {
                    padding-left: 0.4em;
                    font-size: 0.85em;
                }
            }
        }
    }
    > div.goal {
        // > div.progress {
        //  max-width: 330px;
        //  margin: 0.4em 0;
        // }
        > #vue-gauge {
            padding: 0 1em;
            svg {
                overflow: visible;
                > text:first-of-type {
                    font-size: 11px;
                }
                > text:last-of-type {
                    font-size: 12px;
                    transform: translateX(0.5em);
                }
            }
        }
        > div.item {
            > div:first-child {
                width: 100px;
            }

            // &.Rem div:nth-child(2) {
            //  color: #dc3545;
            // }
            &.Exc div:nth-child(2) {
                color: #28a745;
            }
        }
    }
    > div.ppl {
        > div.item {
            > div:first-child {
                width: 220px;
                flex-shrink: 0;
                .tt-info svg {
                    margin: 0 0.2em;
                }
            }
            > div:nth-child(2) {
                span:empty::before {
                    content: "-";
                    font-weight: normal;
                }
            }
        }
    }
}

.rf-revenue-view-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5em 1em;
    padding: 0.5em 0.75em;
    margin-bottom: 0.75em;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 0.25em;

    .rf-revenue-view-lbl {
        font-size: 0.85em;
        font-weight: 600;
        color: #495057;
        margin-right: 0.35em;
    }
}

.rf-revenue-view-group,
.rf-forecast-filter-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.35em 0.5em;
}

.rf-revenue-view-divider {
    width: 1px;
    align-self: stretch;
    min-height: 28px;
    background: #ced4da;
    margin: 0 0.25em;
}

.rf-forecast-filter {
    padding: 0;

    .btn-link {
        color: #495057;
        padding: 0.1em 0.3em;
    }
}

.rf-forecast-filter-panel {
    padding: 0.75em;
    min-width: 200px;
}

.rf-forecast-filter-section {
    margin-bottom: 0.6em;

    label {
        display: block;
        font-weight: 600;
        font-size: 0.85em;
        margin-bottom: 0.2em;
    }
}

.rf-forecast-stage-list {
    max-height: 120px;
    overflow-y: auto;
}

.rf-forecast-stage-item {
    font-size: 0.9em;
}
.rf-forecast-status-list {
    max-height: 120px;
    overflow-y: auto;
}

.rf-forecast-status-item {
    font-size: 0.9em;
}

.rf-forecast-filter-toggles {
    display: flex;
    align-items: center;
    gap: 1em;

    label {
        display: flex;
        align-items: center;
        gap: 0.3em;
        margin: 0;
        cursor: pointer;
        font-size: 0.85em;
    }
}

.rf-forecast-toggle-oppr input {
    accent-color: #4caf50;
}

.rf-forecast-toggle-proj input {
    accent-color: #4076ba;
}

#bc-rf-project-info {
    padding: 0.5em;
    overflow-x: auto;
}

#bc-rf-forecast-charts {
    padding: 0.5em;
    overflow-x: auto;

    .rf-forecast-charts-wrap {
        min-width: 700px;
    }
}

#bc-rf-notes {
    max-width: 800px;
    > div {
        text-align: left;
        padding: 0.5em;
        margin: 0.5em 0;

        border: solid 0.1em #ced4da;
        // border: solid 0.1em red;
        > div.title {
            font-weight: bolder;
            font-size: 0.85em;
            text-decoration: underline;
        }
        // > div.items-cont {
        //  // border: solid 0.1em #ced4da;
        //  // border-radius: 0.25em;
        //  // max-height: 300px;
        //  // overflow-y: auto;
        // }

        > div.items-cont > div.item {
            padding: 0.2em;
            // margin-bottom: 0.5em;
            > div.input-group {
                width: unset;
                flex-grow: 1;
                textarea {
                    line-height: 1em;
                    min-height: 50px;
                    max-height: 200px;
                    // background-color: #f8f9fa;
                }
                .input-group-append {
                    // border: solid 0.1em red;
                    flex-wrap: wrap;
                    align-self: flex-start;
                    width: 30px;
                    .btn {
                        width: 20px;
                        height: 20px;
                        opacity: 0.6;
                        // background-color: #e9ecef;
                        box-shadow: unset;
                        font-size: 0.9em;

                        margin: 0 auto;
                        margin-bottom: 0.5em;
                        padding: 0;
                        &:hover {
                            opacity: unset;
                            background-color: #e9ecef;
                            border-radius: 0.25em;
                        }
                    }
                    .btn-delete {
                        color: #dc3545;
                    }
                    .btn-edit {
                        color: #4fa4ff;
                    }
                    .btn-save {
                        color: #28a745;
                    }
                }
            }

            > div.info {
                text-align: right;
                padding-right: 30px;
                line-height: 0.9em;
                span {
                    font-size: 0.75em;
                    padding-right: 0.5em;
                }
            }
        }

        > .btn-add {
            font-size: 0.9em;
        }
    }
}

.modal .modal-dialog #bm-create-goal-yr {
    padding-top: 0.5em;
    > select {
        width: unset;
    }
    > p {
        font-size: 0.9em;
        color: #495057;
    }
}
.btn-save {
    color: #fff;
    background-color: #4fa4ff;
    border-color: none;
    margin-right: 10px;
}
.btn-cancel {
     color: red;
     background-color: #ffc107;
     border-color: none;
}
.btn-save:hover{
     background-color: #3f83cc !important;
}
.btn-cancel:hover {
  background-color: #e6ac06 !important;
}
.kt-select {width:290px;}
.teamFilter {margin-left: auto;}
/* Remove default BootstrapVue dropdown styling */
.dropdown-menu {
  border: none !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important; /* light shadow */
  padding: 6px 0 !important;
  background: white !important;
  min-width: 200px !important;
}
/* Remove extra padding Bootstrap adds */
.export-menu {
  border: none !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important;
  padding: 6px 0 !important;
  background: #fff !important;
  min-width: 200px;
}
summary {list-style: none}
summary::-webkit-details-marker {display: none; }
details summary::before { 
  content:"🡒"; 
  color: #1E90FF; 
  /* you can style it however you want, use background-image for example */
}

/* By using [open] we can define different styles when the disclosure widget is open */
details[open] summary::before { 
  content:"🠣";  /*"🡑"*/ 
  color: #1E90FF; 
}
.buttonBar{
	 margin-left: auto;   /* pushes buttons to the far right */
     gap: 12px;
	 align-items: center;
}
</style>

